<template>
    <Modal
        v-model="showModal"
        title="供货计划详情"
        :mask-closable="false"
        width="800"
        class="presale-plan-modal"
    >
        <a slot="close" class="ivu-modal-close" @click="handleClose">
            <Icon type="ios-close"></Icon>
        </a>

        <div class="modal-content">
            <Spin size="large" fix v-if="loading"></Spin>

            <div v-if="detailData">
                <div class="highlight-panel">
                    <div class="highlight-item">
                        <span class="label">当前供货数量</span>
                        <span class="value primary">{{ detailData.preSalePlanOfferAmount || 0 }}</span>
                    </div>
                    <div class="divider"></div>
                    <div class="highlight-item">
                        <span class="label">当前供货价格</span>
                        <span class="value price">
                            <small>¥</small>{{ formatPrice(detailData.preSalePlanPrice) }}
                        </span>
                    </div>
                    <div class="divider"></div>
                    <div class="highlight-item">
                        <span class="label">更新时间</span>
                        <span class="value time">{{ formatDateTime(detailData.CreateTime) }}</span>
                    </div>
                </div>

                <div class="info-card-container">
                    <div class="section-header">
                        <span class="title">基础与产品信息</span>
                    </div>
                    <div class="info-grid">
                        <div class="grid-item">
                            <span class="label">年份/周次</span>
                            <span class="text">{{ detailData.preSaleYear || '--' }} 年 / {{ detailData.preSaleWeek || '--' }} 周</span>
                        </div>
                        <div class="grid-item">
                            <span class="label">绑定周期</span>
                            <span class="text">{{ detailData.seedFarmWeekBindingName || '--' }}</span>
                        </div>
                        <div class="grid-item">
                            <span class="label">产品名称</span>
                            <span class="text bold">{{ detailData.productName || '--' }}</span>
                        </div>
                        <div class="grid-item">
                            <span class="label">产品编号</span>
                            <span class="text">{{ detailData.productCode || '--' }}</span>
                        </div>
                        <div class="grid-item">
                            <span class="label">规格</span>
                            <span class="text">{{ detailData.productSpec || '--' }}</span>
                        </div>
                        <div class="grid-item">
                            <span class="label">苗场信息</span>
                            <span class="text" :title="detailData.seedFarmName">
                                {{ detailData.seedFarmName || '--' }} 
                                <span class="sub-text" v-if="detailData.seedFarmCode">({{ detailData.seedFarmCode }})</span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="change-log-section" v-if="detailData.oldValue || detailData.newValue || oldValue || newValue">
                    <div class="section-header">
                        <span class="title">变更记录</span>
                    </div>
                    <div class="diff-container">
                        <div class="diff-box old">
                            <div class="diff-label"><Icon type="md-remove-circle" /> 修改前</div>
                            <div class="diff-content">
                                {{ formatChangeValue(detailData.oldValue || oldValue) || '无数据' }}
                            </div>
                        </div>
                        <div class="diff-arrow">
                            <Icon type="md-arrow-round-forward" />
                        </div>
                        <div class="diff-box new">
                            <div class="diff-label"><Icon type="md-add-circle" /> 修改后</div>
                            <div class="diff-content">
                                {{ formatChangeValue(detailData.newValue || newValue) || '无数据' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loading && (!detailData || (!detailData.productCode && !detailData.preSaleYear && !oldValue && !newValue))" class="empty-state">
                <div class="empty-icon">
                    <Icon type="ios-filing-outline" />
                </div>
                <p>暂无详细计划数据</p>
            </div>
        </div>

        <!-- <div slot="footer">
            <Button type="primary" size="large" long @click="handleClose">关 闭</Button>
        </div> -->
    </Modal>
</template>

<script>
import { getOnePreSalePlan } from '@/api/modules/preSale-management/preSale-plan';

export default {
    name: 'PresalePlanModal',
    data() {
        return {
            showModal: false,
            detailData: {
                preSaleYear: '',
                preSaleWeek: '',
                productCode: '',
                productName: '',
                productSpec: '',
                preSalePlanOfferAmount: 0,
                preSalePlanPrice: 0,
                CreateTime: '',
                oldValue: '',
                newValue: '',
                status: 0
            },
            loading: false,
            targetID: '',
            oldValue: '',
            newValue: '',
            createTime: ''
        };
    },
    methods: {
        open(targetID, oldValue, newValue, createTime) {
            if (!targetID) {
                this.$Message.warning('无效的计划ID');
                return;
            }
            this.targetID = targetID;
            this.oldValue = oldValue;
            this.newValue = newValue;
            this.createTime = createTime;
            this.showModal = true;
            this.getPreSalePlan(targetID);
        },
        close() {
            this.showModal = false;
            this.detailData = {
                preSaleYear: '',
                preSaleWeek: '',
                productCode: '',
                productName: '',
                productSpec: '',
                preSalePlanOfferAmount: 0,
                preSalePlanPrice: 0,
                CreateTime: '',
                oldValue: '',
                newValue: '',
                status: 0
            };
            this.loading = false;
            this.targetID = '';
            this.oldValue = '';
            this.newValue = '';
            this.createTime = '';
        },
        handleClose() {
            this.close();
        },
        async getPreSalePlan(targetID) {
            if (!targetID) return;
            this.loading = true;
            try {
                const res = await getOnePreSalePlan({ TargetID: targetID });
                if (res && res.code === 0) {
                    const apiData = res.data.onePreSalePlanModel || {};
                    this.detailData = {
                        preSaleYear: apiData.preSaleYear || '',
                        preSaleWeek: apiData.preSaleWeek || '',
                        productCode: apiData.productCode || '',
                        productName: apiData.productName || '',
                        productSpec: apiData.productSpec || '',
                        preSalePlanOfferAmount: apiData.preSalePlanOfferAmount || 0,
                        preSalePlanPrice: apiData.preSalePlanPrice || 0,
                        seedFarmWeekBindingName: apiData.seedFarmWeekBindingName || '',
                        seedFarmCode: apiData.seedFarmCode || '',
                        seedFarmName: apiData.seedFarmName || '',
                        CreateTime: this.createTime || apiData.CreateTime || '',
                        status: apiData.status || 0,
                        oldValue: this.oldValue || '',
                        newValue: this.newValue || ''
                    };
                } else {
                    this.$Message.error(res.message || '获取详情失败');
                    this.fallbackData();
                }
            } catch (error) {
                console.error('获取失败:', error);
                this.$Message.error('系统异常，请稍后重试');
                this.fallbackData();
            } finally {
                this.loading = false;
            }
        },
        fallbackData() {
            this.detailData = {
                preSaleYear: '',
                preSaleWeek: '',
                productCode: '',
                productName: '',
                productSpec: '',
                preSalePlanOfferAmount: 0,
                preSalePlanPrice: 0,
                CreateTime: this.createTime || '',
                status: 0,
                oldValue: this.oldValue || '',
                newValue: this.newValue || ''
            };
        },
        formatPrice(price) {
            if (!price && price !== 0) return '0.00';
            return parseFloat(price).toFixed(2);
        },
        formatDateTime(dateTime) {
            if (!dateTime) return '--';
            try {
                const date = new Date(dateTime);
                return date.toLocaleString('zh-CN', {
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            } catch (error) {
                return dateTime;
            }
        },
        formatChangeValue(value) {
            if (!value) return '';
            try {
                const parsed = JSON.parse(value);
                return JSON.stringify(parsed, null, 2);
            } catch (error) {
                return value;
            }
        }
    }
};
</script>

<style lang="less" scoped>
// 变量定义
@primary-color: #2d8cf0;
@text-main: #333;
@text-sub: #808695;
@bg-light: #f8f8f9;
@border-color: #e8eaec;

.presale-plan-modal {
    /deep/ .ivu-modal-body {
        padding: 0;
    }
    /deep/ .ivu-modal-footer {
        border-top: none;
        padding: 10px 20px 20px;
    }

    .modal-content {
        padding: 24px;
        max-height: 650px;
        overflow-y: auto;
    }

    // 顶部高亮面板
    .highlight-panel {
        display: flex;
        justify-content: space-around;
        align-items: center;
        background: #f0faff;
        border: 1px solid fade(@primary-color, 10%);
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 24px;

        .highlight-item {
            text-align: center;
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 4px;

            .label {
                font-size: 12px;
                color: @text-sub;
            }

            .value {
                font-size: 18px;
                font-weight: 600;
                color: @text-main;
                font-family: 'Helvetica Neue', sans-serif;

                &.primary { color: @primary-color; font-size: 20px; }
                &.price { color: #ff9900; font-size: 20px; }
                &.time { font-size: 14px; font-weight: normal; color: @text-main; }
                
                small { font-size: 12px; margin-right: 2px; }
            }
        }

        .divider {
            width: 1px;
            height: 30px;
            background-color: #dcdee2;
        }
    }

    // 统一的卡片容器
    .info-card-container, .change-log-section {
        margin-bottom: 20px;
    }

    .section-header {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        
        .title {
            font-size: 15px;
            font-weight: 700;
            color: @text-main;
            position: relative;
            padding-left: 10px;
            
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                height: 14px;
                width: 3px;
                background-color: @primary-color;
                border-radius: 2px;
            }
        }
    }

    // Grid 布局
    .info-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        background: @bg-light;
        padding: 20px;
        border-radius: 6px;

        .grid-item {
            display: flex;
            flex-direction: column;
            gap: 6px;

            .label {
                color: @text-sub;
                font-size: 12px;
            }
            .text {
                color: @text-main;
                font-size: 14px;
                word-break: break-all;

                &.bold { font-weight: 600; }
                
                .sub-text {
                    color: @text-sub;
                    font-size: 12px;
                    margin-left: 4px;
                }
            }
        }
    }

    // 变更记录样式
    .diff-container {
        display: flex;
        align-items: stretch;
        gap: 12px;

        .diff-arrow {
            display: flex;
            align-items: center;
            color: @text-sub;
            font-size: 20px;
        }

        .diff-box {
            flex: 1;
            border-radius: 6px;
            border: 1px solid @border-color;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .diff-label {
                padding: 8px 12px;
                font-size: 12px;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 6px;
            }

            .diff-content {
                padding: 12px;
                font-size: 13px;
                // 增加 font-weight 实现加粗
                font-weight: bold; 
                font-family: Consolas, Monaco, monospace;
                white-space: pre-wrap;
                flex: 1;
                background: #fff;
                min-height: 80px;
                color: @text-main;
            }

            &.old {
                border-color: fade(#ed4014, 30%);
                .diff-label { background: #fff1f0; color: #ed4014; }
                .diff-content { background: #fff; }
            }

            &.new {
                border-color: fade(#19be6b, 30%);
                .diff-label { background: #f6ffed; color: #19be6b; }
                .diff-content { background: #fff; }
            }
        }
    }

    // 空状态
    .empty-state {
        text-align: center;
        padding: 40px 0;
        
        .empty-icon {
            font-size: 48px;
            color: #e8eaec;
            margin-bottom: 10px;
        }
        p { color: @text-sub; }
    }
}
</style>